import { MockFactory } from '@tino-frontend/mocks'
import { LegalPerson } from '@types'

export const legalPersonAPIMock = new MockFactory<LegalPerson>({
  id: '58940867-a6a8-44a3-b9dc-aa86181b2983',
  document_number: '40970583000106',
  document_type: 'CNPJ',
  name: 'ROBSON DANTAS MATHIAS CONSULTORIA EM TECNOLOGIA DA INFORMACAO',
  buyer_info_required: false,
  legal_entity_document_required: false,
  power_of_attorney_required: false,
  power_of_attorney_upload_required: false,
  signature_required: false,
  signature_status: 'pending',
  social_document_required: false,
  status: 'waiting_analysis',
})
